<input (click)="inicia()" class="inputAutocomplete" type="text" #autocomplete id="autocomplete"
    placeholder="{{placeholder | translate}}" [(ngModel)]="formattedAddress" />
<div class="separador"></div>